import Layout from "./Layout";

export default function NoSuchOrganization(): JSX.Element {
  return (
    <Layout title="Organization Not Found">
      <p>
        There's no organization with this URL. Please double-check your URL and
        try again.
      </p>
    </Layout>
  );
}
